import React from 'react';
import { Routes, Route } from 'react-router-dom';

//Layouts
import NonAuthLayout from '../Layouts/NonAuthLayout';
import VerticalLayout from '../Layouts/index';

//routes
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import { AuthProtected } from './AuthProtected';
import PrivacyPolicy from '../pages/PrivacyPolicy/index.js';
import useAppSettings from '../Components/Hooks/useAppSettings.js';
import { useLoggedUser, useProfile } from '../Components/Hooks/useUserHooks.js';
import Navdata from '../Layouts/LayoutMenuData.js';
import useQuery from '../Components/Hooks/useQuery.js';
import canAccessRoute from '../Routes/helpers/canAccessRoute.js';
import { setAuthorization } from '../helpers/api_helper.js';

const Index = () => {
	const { userProfile } = useLoggedUser();
	const navData = Navdata();
	useAppSettings();
	const query = useQuery(); // Get query from route
    const external_jwt = query.get("external_jwt"); // Get external JWT from query

	if(external_jwt){
		const authUser = {
			access_token: external_jwt,
			privacy_policy: true,
		};
		localStorage.setItem('authUser', JSON.stringify(authUser));
		setAuthorization(external_jwt);
	}


	return (
		<React.Fragment>
			<Routes>
				<Route path='/privacy_policy' element={<PrivacyPolicy />} />
				<Route>
					{publicRoutes.map((route, idx) => (
						<Route
							path={route.path}
							element={<NonAuthLayout>{route.component}</NonAuthLayout>}
							key={idx}
							exact={true}
						/>
					))}
				</Route>

				<Route>
					{authProtectedRoutes.map(
						(route, idx) =>
							canAccessRoute(route, userProfile, external_jwt)
								? (
									<Route
										path={route.path}
										element={
											<AuthProtected external_jwt={external_jwt}>
												<VerticalLayout
													shouldHideMainMenu={(
														!external_jwt
															? false : true
													)}
												>
													{route.component}
												</VerticalLayout>
											</AuthProtected>
										}
										key={idx}
										exact={true}
									/>
								) : null // de lo contrario, no permitir
					)}
				</Route>
			</Routes>
		</React.Fragment>
	);
};

export default Index;
